import { formatDate } from "../common/BaseUtil"
import { useState, useEffect } from 'react';
import { basePort, headers, setTokenHeader, renderRedirect, getJwtFromCookies, isExpiredJwt, getUsernameJwt } from "../../module_auth/AuthService"
import { ToastMessage } from "../../component/common/Toast"
import { ModalMessage } from "../../component/common/Modal"
import { REPLY_MESSAGE_NO_AUTH } from './CmtyConstant'
//icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faReply, faHeart as solidHeart} from '@fortawesome/free-solid-svg-icons';
import { faClock, faUser, faComment, faHeart } from '@fortawesome/free-regular-svg-icons';
import '../../App.css'
import './Cmty.css'

export function CmtyBaseReply(props) {
    const [hiddenReplyTextField, setHiddenReplyTextField] = useState(true);
    const [hiddenReplyCancelBtn, setHiddenReplyCancelBtn] = useState(true);

    const [redirect, setRedirect] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState("");
    const [accessToken, setAccessToken] = useState("");
    const [hiddenEditDropdown, setHiddenEditDropdown] = useState(true);

    const [cmtyReply, setCmtyReply] = useState("");

    const [textareaDisabled, setTextareaDisabled] = useState(false);
    const [placeHolderMessage, setPlaceHolderMessage] = useState("");

    const [hiddenReplyEditor, setHiddenReplyEditor] = useState(true);
    const [replyEditorContent, setReplyEditorContent] = useState("");

    //modal
    const [showModalLogin, setShowModalLogin] = useState(false);
    const [showModalDelete, setShowModalDelete] = useState(false);

    //toast
    const [showToast, setShowToast] = useState(false);
    const [msgToast, setMsgToast] = useState("");

    useEffect(() => {
        if(getJwtFromCookies() == null || isExpiredJwt(getJwtFromCookies())){
            setHiddenEditDropdown(true)
            setTextareaDisabled(true)
            setPlaceHolderMessage(REPLY_MESSAGE_NO_AUTH)
        } else {
            setAccessToken(getJwtFromCookies())
            setTextareaDisabled(false)
            setPlaceHolderMessage("")
            if(getUsernameJwt(getJwtFromCookies()) === props.object.username){
                setHiddenEditDropdown(false)
            } else {
                setHiddenEditDropdown(true)
            }
        }
        loadCmtyReplyEditorContent()
    }, []);

    function loadCmtyReplyEditorContent(){
        setReplyEditorContent(props.object.content)
    }

    function shwoReplyTextField(){
        if(accessToken){
            setHiddenReplyTextField(false)
            setHiddenReplyCancelBtn(false)
        } else {
            clickModalLoginBtn()
        }
        
    }

    function hideReplyTextField(){
        setHiddenReplyTextField(true)
        setHiddenReplyCancelBtn(true)
    }

    function handleTextarea(event) {
        setCmtyReply(event.target.value);
    }

    function fadeOutToast(msg){
        setToastMessage(true, msg)
        setTimeout(function() {
            setToastMessage(false, "")
        }.bind(this), 1000);
    }

    function setToastMessage(show, message){
        setShowToast(show)
        setMsgToast(message)
    }

    function clickPostReply(event) {
        if(accessToken) {
            setTokenHeader(getJwtFromCookies())
            fetch(basePort + '/reply/cmty', 
            {method:'post', headers,
                        body:JSON.stringify({
                        content:cmtyReply,
                        cmtyPostId:props.object.cmtyPostId,
                        cmtyCommentId:props.object.cmtyCommentId,
                        replyMbrId: props.object.mbrId
                    })})
                    .then(response => response.json())
                    .then(response => {
                    if(response.validRequest){
                        fadeOutToast(response.validationMessage)
                        console.log(response.validationMessage)
                        setTimeout(function() {
                            window.location.reload();
                        }.bind(this), 1000)
                    } else {
                        fadeOutToast(response.validationMessage)
                    }
            }).catch(function(error) {
                console.log(error);
            });
        } else {
            clickModalLoginBtn()
        }
    }

    function clickReplyEdit(event) {
        setHiddenReplyEditor(false)
    }

    function handleReplyEditorContent(event) {
        setReplyEditorContent(event);
    }

    function cancelReplyEdit(event) {
        setHiddenReplyEditor(true)
    }

    //수정 등록
    function postReplyEdit(event) {
        setTokenHeader(getJwtFromCookies())
        fetch(basePort + '/update/cmty/reply', 
            {method:'post', headers,
                        body:JSON.stringify({
                        content:replyEditorContent,
                        cmtyReplyId:props.object.id,
                    })})
                    .then(response => response.json())
                    .then(response => {
                    if(response.validRequest){
                        fadeOutToast(response.validationMessage)
                        setTimeout(function() {
                            window.location.reload();
                        }.bind(this), 3000)
                    } else {
                        fadeOutToast(response.validationMessage)
                    }
        }).catch(function(error) {
            console.log(error);
        });
    }

    //modal login
    function closeModalLoginBtn(){
        setShowModalLogin(false)
    }

    function submitModalLoginBtn(){
        setShowModalLogin(false)
        setRedirectUrl('/login')
        setRedirect(true)
    }

    function clickModalLoginBtn(){
        setShowModalLogin(true)
    }

    //modal delete
    function closeModalDeleteBtn(){
        setShowModalDelete(false)
    }

    function clickModalDeleteBtn(){
        setShowModalDelete(true)
    }

    function submitModalDeleteBtn(){
        setShowModalDelete(false)
        clickReplyDelete()
    }

    //삭제 등록
    function clickReplyDelete(event) {
        setTokenHeader(getJwtFromCookies())
        fetch(basePort + '/delete/cmty/reply', 
            {method:'post', headers,
                        body:JSON.stringify({
                        cmtyReplyId:props.object.id,
                    })})
                    .then(response => response.json())
                    .then(response => {
                    if(response.validRequest){
                        fadeOutToast(response.validationMessage)
                        setTimeout(function() {
                            window.location.reload();
                        }.bind(this), 1000)
                    } else {
                        fadeOutToast(response.validationMessage)
                    }
        }).catch(function(error) {
            console.log(error);
        });
    }

    return (
        <ul class="list-group list-group-flush" style={{marginLeft: "20px"}}>
            {renderRedirect(redirect, redirectUrl)}
            {/* reply block 답글*/}
            <div class="card border-0" key={props.index} hidden={!hiddenReplyEditor}>
                <div class="card-body">
                    <p class="card-text" className="comment-reply-nickname">
                        {/* 답글 작성자 닉네임 */}
                        {props.object.nickname} 
                        <div class="dropdown show" hidden={hiddenEditDropdown} style={{fontFamily: 'Nanum Gothic'}}>
                            <a class="dropdown-toggle custom-dropdown-toggle" aria-expanded="true" data-bs-toggle="dropdown" 
                                style={{color:"black", fontWeight:'bold', textDecoration:"none"}} data-bs-display="static">...</a>
                            {/* ... 버튼 클릭후 답글 수정 또는 삭제 */}
                            <div class="dropdown-menu custom-dropdown" data-bs-popper="none">
                                <a class="dropdown-item pulse animated" onClick={clickReplyEdit}>수정</a>
                                <a class="dropdown-item pulse animated" onClick={clickModalDeleteBtn}>삭제</a>
                            </div>
                        </div>
                    </p>
                    {/* 답글내용 */}
                    <p class="card-text"><FontAwesomeIcon icon={faAt} style={{marginRight:"2px"}}/>
                        <span style={{fontWeight: 'bold'}}>{props.object.replyNickname}</span>
                        <pre>{props.object.content}</pre>
                    </p>
                    {/* 답글내용에 답글쓰기  */}
                    <p class="card-text">{formatDate(props.object.updateAt)} {/* 답글 등록날짜 */}
                        <button type="button" class="btn btn-link" style={{color:"grey", textDecoration: "none"}} onClick={shwoReplyTextField}>답글쓰기</button>
                        {/* 답글쓰기 클릭시 답글취소 활성화 */}
                        <button type="button" class="btn btn-link" style={{color:"grey", textDecoration: "none"}} onClick={hideReplyTextField} hidden={hiddenReplyCancelBtn}>답글취소</button>
                    </p>
                </div>
            </div>
            {/* reply update editor 답글 수정버튼 클릭후 활성화: 기존내용 수정가능*/}
            <div class="card-body" hidden={hiddenReplyEditor}>
                <textarea class="form-control" aria-label="Message" value={replyEditorContent} onChange={handleReplyEditorContent}></textarea>
                <div class="card-footer text-muted" style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                    <button type="button" class="btn btn-light" style={{fontSize: "12px", borderRadius: '5px', marginRight:"5px"}} onClick={cancelReplyEdit}>취소</button>
                    <button type="button" class="btn btn-secondary" style={{fontSize: "12px", borderRadius: '5px'}} onClick={postReplyEdit}>등록</button>
                </div>
            </div>
            {/* reply post editor 답글쓰기 클릭시 에디터 활성화: 답글등록 가능 */}
            <div class="card-body" hidden={hiddenReplyTextField}>
                <div class="input-group mb-3">
                    <textarea class="form-control" aria-label="Message" placeholder={placeHolderMessage} onChange={handleTextarea} disabled={textareaDisabled}></textarea>
                    <button type="button" class="btn btn-secondary" style={{fontSize: "12px", borderRadius: '0 5px 5px 0'}} onClick={clickPostReply}>답글등록</button>
                </div>
            </div>
            <ToastMessage show={showToast} msg={msgToast}/>
            <ModalMessage show={showModalLogin} closeBtn={closeModalLoginBtn} 
                                     submitBtn={submitModalLoginBtn} title={"로그인이 필요합니다."} msg={"로그인 페이지로 안내해 드릴까요?"} />
            <ModalMessage show={showModalDelete} closeBtn={closeModalDeleteBtn} 
                                    submitBtn={submitModalDeleteBtn} title={"삭제 확인"} msg={"정말로 이 항목을 삭제하시겠습니까?"} />
        </ul>
        
    );
}